export const mutationKeys = {
  all: () => ["adminEngagementBlueprints"],
  create: () => [...mutationKeys.all(), "create"],
  update: () => [...mutationKeys.all(), "update"],
  delete: () => [...mutationKeys.all(), "delete"],
  bulkAdminBlueprintActivitiesOperations: () => [
    ...mutationKeys.all(),
    "bulkAdminBlueprintActivitiesOperations"
  ]
};
